// helpers
import DTM from 'shared/helpers/DTM';

let tagsClicked: string[] = [];

export const onTagClicked = (tagTitle: string) => {
  if (tagsClicked.length === 0) {
    DTM.track('first-responsible-tag-clicked', { tagTitle: tagTitle });
  }

  if (!tagsClicked.includes(tagTitle)) {
    tagsClicked.push(tagTitle);
  }
};

export const onTagsUnmount = () => {
  if (tagsClicked.length > 1) {
    DTM.track('responsible-tags-clicked', { tagList: tagsClicked.join(',') });
    tagsClicked = [];
  }
};
